import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

// Ban timestamps come from the game client's own moderation-ban format, "yyyyMMdd HH:mm:ss" UTC
// (no dashes/colons in the date part - see the AirWars3 mod's PlayerBanState.cs). Not an ISO
// format Date() can parse directly.
export const parseBanTimestamp = (ts) => {
  if (!ts || ts.length < 17) return null;
  const year = parseInt(ts.slice(0, 4), 10);
  const month = parseInt(ts.slice(4, 6), 10) - 1;
  const day = parseInt(ts.slice(6, 8), 10);
  const hour = parseInt(ts.slice(9, 11), 10);
  const minute = parseInt(ts.slice(12, 14), 10);
  const second = parseInt(ts.slice(15, 17), 10);
  const date = new Date(Date.UTC(year, month, day, hour, minute, second));
  return isNaN(date.getTime()) ? null : date;
};

// Shows a ban's current state (None / Banned / Expired), with the exact expiry - and, where the
// viewer is allowed to see it (deputies/admins looking up another player - self-views have the
// reporter's login redacted to "admin" server-side), who applied it and why - on hover.
//
// currentLogin/isAdmin/onDelete are optional - only the admin Players lookup view (a deputy
// looking up another player) passes them. When present, a delete icon shows if this viewer is
// allowed to remove the ban: admins can remove any ban, everyone else only the ones they created
// themselves (ban.login === currentLogin) - mirrored server-side in PlayerBanRemoveHandler, which
// is the actual enforcement; this is just what decides whether to offer the icon at all.
const BanStatus = ({ ban, currentLogin, isAdmin, onDelete }) => {
  if (!ban || !ban.expires) {
    return <span>None</span>;
  }
  const expiresDate = parseBanTimestamp(ban.expires);
  const isActive = expiresDate && expiresDate.getTime() > Date.now();
  const details = [
    expiresDate ? `Expires: ${expiresDate.toLocaleString()}` : null,
    ban.login ? `By: ${ban.login}` : null,
    ban.reason ? `Reason: ${ban.reason}` : null,
  ].filter(Boolean).join(' — ');
  const canDelete = !!onDelete && (isAdmin || (ban.login && currentLogin &&
    ban.login.toLowerCase() === currentLogin.toLowerCase()));
  return (
    <span>
      <span title={details} style={{ color: isActive ? '#c0392b' : 'inherit', cursor: 'help' }}>
        {isActive ? 'Banned' : 'Expired'}
      </span>
      {canDelete && (
        <Tooltip title="Remove this ban">
          <IconButton onClick={onDelete} color="error" aria-label="remove ban" size="small">
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </span>
  );
};

export default BanStatus;
